import { axios } from 'ui/api/requestClient/recruiter';

export { axios };
